<div class="card">
	<div class="card-body">
		<h6 class="card-title">{{ attachment.name }}</h6>
		<p class="card-text">
			<ng-container *ngIf="attachment.customMetadata?.description; else noDescription">
				{{ attachment.customMetadata?.description }}
			</ng-container>
			<ng-template #noDescription>
				<small>
					<em>No Description Available</em>
				</small>
			</ng-template>
		</p>
		<p class="card-text metadata">
			<small class="text-body-secondary">
				<i class="bi bi-file-earmark-person"></i>
				{{ attachment.customMetadata?.uploadedByName || 'Unknown' }}
			</small>
			<small class="text-body-secondary">
				<i class="bi" [ngClass]="getFileIcon(attachment.contentType)"></i>
				{{ attachment.size | fileSize }}
			</small>
		</p>
		<div class="actions">
			<ng-container *ngIf="!readonly">
				<ng-container *ngIf="!attachment.customMetadata?.locked">
					<button type="button" class="btn btn-sm btn-outline-primary" (click)="editAttachmentDescription.emit(attachment)">
						<i class="bi bi-pencil"></i>
						Description
					</button>
				</ng-container>
			</ng-container>
			<a target="_blank" class="btn btn-sm btn-primary" [href]="attachment.downloadUrl">
				<i class="bi bi-eye"></i>
				View
			</a>
		</div>
	</div>
	<ng-container *ngIf="!readonly">
		<ng-container *ngIf="attachment.customMetadata?.locked; else unlocked">
			<i class="bi bi-lock top-right"></i>
		</ng-container>
		<ng-template #unlocked>
			<button type="button" class="btn btn-close top-right" aria-label="Close" (click)="removeAttachment.emit(attachment)"></button>
		</ng-template>
	</ng-container>
	<div class="card-footer">
		<small class="text-body-secondary" [title]="attachment.timeCreated | date: 'medium'">
			Uploaded {{ attachment.timeCreated | relativeTime }}
		</small>
	</div>
</div>
